import React from 'react';
import _ from 'lodash';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Content,
  Block,
} from 'components/landing/components';

import config from 'config/offer';
import { GetInTouch } from './getInTouch';

const dumbOffer = dumbBem('l-offer');
const Label = tx([{ element: 'label' }, dumbOffer])('div');
const Location = tx([{ element: 'location' }, dumbOffer])('div');
const Compensation = tx([{ element: 'compensation' }, dumbOffer])('div');

const Header = ({
  title,
  locations,
  compensation,
  apply,
}) => {
  return (
    <Block modifier="header">
      <Content modifier="header">
        <Title>{title}</Title>

        <Location>
          <Label>location:</Label>
          <Title modifier="2">{locations.join(' ')}</Title>
        </Location>

        <Compensation>
          <Label>compensation:</Label>
          <Title modifier="2">{compensation}</Title>
        </Compensation>
      </Content>

      <GetInTouch
        title={config.getInTouch.title}
        content={_.replace(config.getInTouch.content, '#{position_name}', title)}
        onApply={apply}
      />
    </Block>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/landing/pages/offer/Header.js